module.exports = __webpack_public_path__ + "static/media/extraspicymayo.32dbfce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/extraspicymayo.jpg
// module id = 145
// module chunks = 0